__turbopack_context__.v({
  "activeFiltersPresent": "ActiveFiltersOverview-module__yLiQPq__activeFiltersPresent",
  "activeFiltersWrapper": "ActiveFiltersOverview-module__yLiQPq__activeFiltersWrapper",
  "filterChip": "ActiveFiltersOverview-module__yLiQPq__filterChip",
  "isTrunc": "ActiveFiltersOverview-module__yLiQPq__isTrunc",
  "moreLessBtn": "ActiveFiltersOverview-module__yLiQPq__moreLessBtn",
  "noBorder": "ActiveFiltersOverview-module__yLiQPq__noBorder",
});
